import { Link } from "react-router-dom";
import { useTranslations } from "@/contexts/I18nContext";
import { useHouseholdContext } from "@/contexts/HouseholdContext";
import { HouseholdManagement } from "@/components/features/HouseholdManagement";

/**
 * Dedicated `/account/households` route — Households CRUD parity with iOS
 * `HouseholdsView.swift` and Android `HouseholdsScreen.kt`. Wave N.1a.
 *
 * The QR / invite flow is owned by Wave N.1b in a sibling worktree, which
 * will extend `HouseholdManagement` with a per-row QR button. This page
 * delegates rendering to that component (with `showLeaveAction`) so the
 * two waves merge cleanly.
 */
export function AccountHouseholdsPage() {
  const t = useTranslations();
  const { loading } = useHouseholdContext();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div
          className="w-8 h-8 border-3 border-t-transparent rounded-full animate-spin"
          style={{
            borderColor: "var(--accent-color, #00C7BE)",
            borderTopColor: "transparent",
          }}
        />
      </div>
    );
  }

  return (
    <div className="p-4 space-y-5">
      {/* Back link to account */}
      <Link
        to="/account"
        className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M15 18l-6-6 6-6" />
        </svg>
        <span>{t("households.back")}</span>
      </Link>

      <h1 className="text-2xl font-bold">{t("households.pageTitle")}</h1>

      <HouseholdManagement showLeaveAction />
    </div>
  );
}
